const reportWebVitals = (_onPerfEntry?: (metric: unknown) => void) => {};
export default reportWebVitals;
